import { useTrafficVisitTrendWithPreviousPeriod } from '@/api/common';
import { type DashboardWidgetComponentProps } from '@/components/Dashboard/types';
import TrafficEfficiencyTrendChart from '@/features/charts/TrafficEfficiencyTrendChart';

const TrafficEfficiencyWidget = ({ pageFilters }: DashboardWidgetComponentProps) => {
  const { startDate, endDate } = pageFilters;
  const { currentPeriodData, previousPeriodData, isLoading, error } =
    useTrafficVisitTrendWithPreviousPeriod(startDate, endDate);

  return (
    <TrafficEfficiencyTrendChart
      currentPeriodData={currentPeriodData}
      previousPeriodData={previousPeriodData}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default TrafficEfficiencyWidget;
